/* eslint-disable */
import { Dates, LocalDate, } from '../util/dates';
import { Observable, Observer } from 'rxjs';
import { Order, OrderType, Services, } from '../util/services';
import { MemStorage } from '../util/mem-storage';
import { Injectable } from '@angular/core';
import { UiConstants } from '../../util/core-utils';
import { LegacyProcess } from './legacy-process.service';
import { LoggedInUserStorage } from '../util/storages';

/* eslint-enable */

@Injectable()
export class LegacyProcessSearchService {

  constructor() {
  }

  getSearchData(request: LegacyProcessSearch.SearchDataGetRequest): Observable<LegacyProcessSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<LegacyProcessSearch.SearchDataResult>) => {
      try {
        observer.next(storage.read(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  setSearchData(request: LegacyProcessSearch.SearchDataSetRequest): Observable<LegacyProcessSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<LegacyProcessSearch.SearchDataResult>) => {
      try {
        observer.next(storage.save(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  resetSearchData(request: LegacyProcessSearch.SearchDataGetRequest): Observable<LegacyProcessSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<LegacyProcessSearch.SearchDataResult>) => {
      try {
        observer.next(storage.reset(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  private createStorage(): LegacyProcessSearch.Storage {
    return new LegacyProcessSearch.Storage();
  }

}

export namespace LegacyProcessSearch {


  export interface SearchDataGetRequest {
  }

  export interface SearchDataSetRequest {
    searchData: SearchData;
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<LegacyProcess.OrderField>;
    processId: string;
    state?: LegacyProcess.LegacyProcessState;
    workflowName: string;
    name: string;
    deadlineFrom: LocalDate;
    deadlineTo: LocalDate;
    externalId: string;
    numberOfOrdersFrom: string;
    numberOfOrdersTo: string;
    creationTimeFrom: LocalDate;
    creationTimeTo: LocalDate;
  }

  interface StoredSearchRawDataBase {
    version: number;
  }

  interface StoredSearchRawData extends StoredSearchRawDataBase {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<LegacyProcess.OrderField>;
    processId: string;
    state?: LegacyProcess.LegacyProcessState;
    workflowName: string;
    name: string;
    deadlineFrom?: string;
    deadlineTo?: string;
    externalId: string;
    numberOfOrdersFrom: string;
    numberOfOrdersTo: string;
    creationTimeFrom?: string;
    creationTimeTo?: string;
  }

  export class Storage {

    /**
     * Increment this version if you change the SearchData interface.
     */
    private static readonly VERSION: number = 1;

    private static readonly DEFAULT_SEARCH_DATA: SearchData = {
      itemsPerPage: UiConstants.pageNumbers[0],
      pageNumber: 1,
      order: {
        field: LegacyProcess.OrderField.PROCESS_ID,
        type: OrderType.DESC
      },
      processId: '',
      state: undefined,
      workflowName: '',
      name: '',
      deadlineFrom: Dates.emptyLocalDate(),
      deadlineTo: Dates.emptyLocalDate(),
      externalId: '',
      numberOfOrdersFrom: '',
      numberOfOrdersTo: '',
      creationTimeFrom: Dates.emptyLocalDate(),
      creationTimeTo: Dates.emptyLocalDate(),
    };

    constructor() {
    }

    public read(request: SearchDataGetRequest): SearchDataResult {
      const key = this.generateKey();
      let rawBase: StoredSearchRawDataBase;
      try {
        const json = MemStorage.getItem(key);
        if (!json) {
          return this.createDefaultResult();
        }
        rawBase = JSON.parse(json);
      }
      catch (error) {
        return this.createDefaultResult();
      }
      if (Storage.VERSION === rawBase.version) {
        const raw: StoredSearchRawData = <StoredSearchRawData>rawBase;
        return this.fromRaw(raw);
      }
      return this.createDefaultResult();
    }

    public reset(request: SearchDataGetRequest): SearchDataResult {
      return this.save({
        searchData: Storage.DEFAULT_SEARCH_DATA,
      });
    }

    public save(request: SearchDataSetRequest): SearchDataResult {
      const key = this.generateKey();
      const raw = this.toRaw(request.searchData);
      const json = JSON.stringify(raw);
      MemStorage.setItem(key, json);
      return this.read(request);
    }

    private generateKey(): string {
      return 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-LegacyProcess';
    }

    private createDefaultResult(): SearchDataResult {
      return {
        searchData: Storage.DEFAULT_SEARCH_DATA,
      };
    }

    private fromRaw(data: StoredSearchRawData): SearchDataResult {
      return {
        searchData: {
          itemsPerPage: data.itemsPerPage,
          pageNumber: data.pageNumber,
          order: data.order,
          processId: data.processId,
          state: data.state,
          workflowName: data.workflowName,
          name: data.name,
          deadlineFrom: Services.toLocalDate(data.deadlineFrom),
          deadlineTo: Services.toLocalDate(data.deadlineTo),
          externalId: data.externalId,
          numberOfOrdersFrom: data.numberOfOrdersFrom,
          numberOfOrdersTo: data.numberOfOrdersTo,
          creationTimeFrom: Services.toLocalDate(data.creationTimeFrom),
          creationTimeTo: Services.toLocalDate(data.creationTimeTo)
        }
      };
    }

    private toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: Storage.VERSION,
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        processId: data.processId,
        state: data.state,
        workflowName: data.workflowName,
        name: data.name,
        deadlineFrom: Services.localDateToString(data.deadlineFrom),
        deadlineTo: Services.localDateToString(data.deadlineTo),
        externalId: data.externalId,
        numberOfOrdersFrom: data.numberOfOrdersFrom,
        numberOfOrdersTo: data.numberOfOrdersTo,
        creationTimeFrom: Services.localDateToString(data.creationTimeFrom),
        creationTimeTo: Services.localDateToString(data.creationTimeTo)
      }
        ;
    }

  }

}
